import { makeStyles } from '@material-ui/core'
import { WARNING_COLORS } from '../../../../../../asterX-UI'

export const useStyles = makeStyles(theme => ({
  wlViewWrapper: {
    paddingBottom: 48
  },
  statusProgressContent: {
    padding: '4px 12px !important',
    maxWidth: 323
  },
  infoCard: {
    padding: 24,
    backgroundColor: 'white',
    borderRadius: 12
  },
  clientInfo: {
    padding: 16,
    maxWidth: 775,
    margin: 0
  },
  carInfo: {
    maxWidth: 473,
    marginLeft: 'auto'
  },
  price: {
    padding: '0 10px',
    borderRadius: 5,
    backgroundColor: WARNING_COLORS['300'],
    width: 'fit-content'
  },
  discount: {
    padding: '0 10px',
    textDecoration: 'line-through'
  }
}))
